import React from 'react';
import { ReactComponent as Logo } from "../../svg/nissan-logo.svg";

import * as Styled from './Header.styles';

export interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  return (
    <Styled.Wrapper>
      <Logo />
    </Styled.Wrapper>
  );
};

export default Header;
